import { decode } from "jsonwebtoken";

let authExpiredCallback: () => void;
export function setAuthExpiredCallback(callback: () => void) {
    authExpiredCallback = callback;
}

let authToken: string;
let authTokenPromise: Promise<void>;
async function loadAuthToken(embedToken: string) {
    const response = await fetch("/Account/GetAuthTokenFromEmbedToken", {
        method: "POST",
        body: JSON.stringify({ embedToken }),
        headers: { "Content-Type": "application/json" },
    });
    authToken = await response.text();
}

export function processEmbedToken(embedToken: string) {
    return authTokenPromise || (authTokenPromise = loadAuthToken(embedToken));
}

let plantystAuthTokenPromise: Promise<string> | undefined;
async function loadPlantystAuthToken() {
    const user = await getUser();
    const token = decode(user.externalAuthentications[0].token, { json: true });
    const exp = token?.exp || 0;
    const tokenRefreshThresholdMs = 1000 * 60 * 60 * 4;
    if (Date.now() + tokenRefreshThresholdMs >= exp * 1000) {
        const response = await fetch("/Account/GetValidExternalAuthToken", {
            headers: {
                "Authorization": "Bearer " + authToken,
            },
        });
        user.externalAuthentications[0].token = await response.text();
    }
    plantystAuthTokenPromise = undefined;
    return user.externalAuthentications[0].token;
}

export function getPlantystAuthToken() {
    return plantystAuthTokenPromise || (plantystAuthTokenPromise = loadPlantystAuthToken());
}

export async function apiFetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
    if (authToken) {
        await checkAuthTokenValidity();
        if (init == null) {
            init = {};
        }
        if (init.headers == null) {
            init.headers = {};
        }
        init.headers!["Authorization"] = "Bearer " + authToken;
    }
    return await fetchOrResetApp(input, init);
}

async function checkAuthTokenValidity() {
    const token = decode(authToken, { json: true });
    const exp = token?.exp || 0;
    const tokenRefreshThresholdMs = 1000 * 60 * 60 * 24 * 2;
    if (Date.now() + tokenRefreshThresholdMs >= exp * 1000) {
        const response = await fetchOrResetApp("/Account/GetAuthToken", { headers: { "Authorization": "Bearer " + authToken } });
        authToken = await response.text();
    }
}

async function fetchOrResetApp(input: RequestInfo, init?: RequestInit): Promise<Response> {
    const response = await fetch(input, init);
    if (response.status === 401 && authExpiredCallback) {
        authExpiredCallback();
    }
    return response;
}

export interface UserDto {
    userId: number;
    externalAuthentications: {
        token: string;
    }[];
    plantystApiUrl: string;
};
let userPromise: Promise<UserDto>;
async function loadUser() {
    const response = await apiFetch("/Account/Get");
    return await response.json() as UserDto;
}
export function getUser() {
    return userPromise || (userPromise = loadUser());
}
